import React from "react";

import TeamShirt from "./TeamShirt";
import EventButton from "./EventButton";

export default class EventButtonContainer extends React.Component {
    constructor(props) {
        super(props);

        this.events = [
            {
                type: "goal",
                leftKey: "5",
                rightKey: "shift+5",
            },
            {
                type: "shot",
                leftKey: "6",
                rightKey: "shift+6",
            },
            {
                type: "freekick",
                leftKey: "7",
                rightKey: "shift+7",
            },
            {
                type: "card",
                leftKey: "8",
                rightKey: "shift+8",
            },
            {
                type: "substitution",
                leftKey: "9",
                rightKey: "shift+9",
            },
            {
                type: "misc",
                leftKey: "0",
                rightKey: "shift+0",
            }
        ];

        // Note, assumption that props.side is immutable
        let useLeft = props.side === "left";
        this.hotkeys = {};
        this.events.forEach((e) => {
            let key = useLeft ? e.leftKey : e.rightKey;
            this.hotkeys[key] = () => this.props.onClicked(e.type, this.props.team);
        });
    }

    componentDidMount () {
        this.props.hotkeyHandler.subscribe(this.hotkeys, this);
    }

    componentWillUnmount () {
        this.props.hotkeyHandler.unsubscribe(this.hotkeys, this);
    }

    render () {
        let style = {
            background: "rgba(0,0,0,0.5)",
            padding: "1px 4px",
        };

        if (this.props.side === "right") {
            style.borderTopLeftRadius = "8px";
            style.borderBottomLeftRadius = "8px";
        } else {
            style.borderTopRightRadius = "8px";
            style.borderBottomRightRadius = "8px";
        }

        let buttons = this.events.map((e) => (
            <li key={e.type}>
                <EventButton
                    height="51px"
                    width="51px"
                    onClicked={this.props.onClicked}
                    team={this.props.team}
                    eventType={e.type} />
            </li>
        ));

        return (
            <ul className="list-unstyled" style={style}>
                <li>
                    <TeamShirt color={this.props.shirtColor} style={{
                        width: "40px",
                        height: "32px",
                        margin: "4px auto 0 auto",
                    }}>
                        <input
                            type="color"
                            value={this.props.shirtColor}
                            onChange={(ev) => this.props.onChangeShirtColor(ev.target.value)} />
                    </TeamShirt>
                </li>
                {buttons}
            </ul>
        );
    }
}



// WEBPACK FOOTER //
// ./src/js/EventButtonContainer.js